import type {RootState} from 'store/types';
import {useAppSelector} from 'store/hooks';
import {useCreateSelectorById} from './useCreateSelectorById';
import type {ExpressionV4} from '../types';

const expressionSelectorById =
  (expressionId: string | undefined) => (state: RootState) =>
    expressionId
      ? state.metadataEdit.metadata?.expressions.find(
          e => e.id === expressionId,
        )
      : undefined;

export const useOptionalExpression = (
  expressionId: string | undefined,
): ExpressionV4 | undefined => {
  const selector = useCreateSelectorById(expressionId, expressionSelectorById);
  return useAppSelector(selector);
};
